<!-- <app-header></app-header> -->
<div class="container-fluid navbar-container g-0">
<!-- <span style="position: absolute; top: 0; left: 0; font-size: 12px"
  >Version: {{ version }}</span
> -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a
        class="navbar-brand"
        target="_blank"
        href="https://www.gov.ph/"
        style="color: #000; font-weight: 700"
        ><strong>GOVPH</strong></a
      >
      <a
        href="#"
        class="d-flex align-items-center col-md-6 col-lg-4 mb-2 mb-md-0 text-dark text-decoration-none"
      >
        <img
          src="assets/baguio-logo-gov.png"
          width="90px"
          height="90px"
          class="city-logo-image"
        />
        <div style="display: flex; flex-direction: column">
          <span class="city-government">Republic of the Philippines</span>
          <hr
            style="
              background-color: #198754;
              margin-top: 5px;
              margin-bottom: 5px;
            "
          />
          <span class="city-name"
            ><strong>City Government of Baguio</strong></span
          >
        </div>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="border-color: #198754"
      >
        <img src="/assets/menu.png" alt="" height="25px" width="25px" />
      </button>
      <div
        class="collapse navbar-collapse collapsed-navbar"
        id="navbarSupportedContent"
      >
      <div class="col-10 navbar-nav">
        <li class="li-nav">
          <a href="#" class="nav-menu p-3">Home</a>
        </li>
        <li class="li-nav">
          <a href="about-us" class="nav-menu p-3">About</a>
        </li>
        <li class="li-nav">
          <a href="services" class="nav-menu p-3">Services</a>
        </li>
        <li class="li-nav">
          <a href="contact-us" class="nav-menu p-3">Contact Us</a>
        </li>
      </div>
        <div class="navbar-nav ms-auto">
          <button
            *ngIf="workPASStokenExist"
            mat-raised-button
            color="primary"
            class="text-white"
            (click)="onNavigateDashboard()"
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  </nav>
</div>


<div class="container">
  <div class="cover">
    <div class="center">
      <img src="assets/images/login.svg" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="700"
        height="500" loading="lazy" style="max-width: 100%" />
    </div>
  </div>
  <div class="forms">
    <div class="form-content">
      <form [formGroup]="loginForm" #form="ngForm" (keydown.enter)="onEnterKey($event)">
        <div class="login-form">
          <div class="title" style="color: #0e0e0e; margin-bottom: 1rem">
            <h1 *ngIf="loginProvider != 2">Login</h1>
            <h4 *ngIf="loginProvider == 2">
              You logged in with your Google account before
            </h4>
          </div>
          <mat-form-field appearance="outline" [style.width.%]="100">
            <mat-label>Email</mat-label>
            <input matInput formControlName="Email" placeholder="juandelacruz@gmail.com" />
          </mat-form-field>
          <div *ngIf="loginForm.get('Email').errors">
            <div class="text text-danger" *ngIf="
                loginForm.get('Email').touched &&
                loginForm.get('Email').errors.required
              ">
              Email is required
            </div>
            <div class="text text-danger mb-3" *ngIf="loginForm.get('Email').errors.pattern">
              Provide a valid email (e.g: juandelacruz@gmail.com)
            </div>
          </div>
          <mat-form-field *ngIf="loginProvider == 1" appearance="outline" [style.width.%]="100">
            <mat-label>Enter your password</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="Password" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide" type="button">
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="loginForm.get('Password').errors">
            <div class="text text-danger" *ngIf="
                loginForm.get('Password').touched &&
                loginForm.get('Password').errors.required
              ">
              Password is required
            </div>
            <div class="text text-danger" *ngIf="
                loginForm.get('Password').touched &&
                loginForm.get('Password').errors.minlength
              ">
              Password is must be at least 8 characters
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <p *ngIf="loginProvider != 2">
                <a href="/forgot-password" class="wp-primary">Forgot Password?</a>
              </p>
              <button mat-raised-button color="primary" [style.width.%]="100" class="text-white my-2 mb-2"
                (click)="signIn()" [disabled]="isDisabledCheck" type="button"
                *ngIf="loginProvider !== 2 && loginProvider !== 1">
                <!-- <mat-icon matPrefix>
                </mat-icon> -->
                Continue
              </button>
              <button mat-raised-button color="primary" [style.width.%]="100" class="text-white my-2" (click)="signIn()"
                type="button" *ngIf="loginProvider == 1" [disabled]="isDisabledCheck">
                Sign in
              </button>

              <mat-progress-bar mode="indeterminate" class="mt-2" *ngIf="isLoading"></mat-progress-bar>


            </div>
          </div>
          <div class="row">
            <div style="text-align: center; margin-top: 15px" *ngIf="loginProvider != 2">
              <hr style="background: #00943a; height: 2px" />
              <span style="
                  position: relative;
                  top: -1.7em;
                  background-color: white;
                  padding: 0 10px;
                ">
                OR
              </span>
            </div>
            <p>
              <button mat-stroked-button type="button" color="primary" (click)="tryGoogle()" [style.width.%]="100"
                style="padding: 0.2rem;">
                <mat-icon *ngIf="isLoadingGoogle">
                  <mat-spinner diameter="20" class="custom-spinner"
                    style="height: 24px; width: 24px; position: absolute; top: 8px; stroke: #00943a;"></mat-spinner>
                </mat-icon>
                <mat-icon matPrefix *ngIf="!isLoadingGoogle">
                  <img src="assets/google.png" class="social-media-icons" alt="" />
                </mat-icon>
                <span *ngIf="!isLoadingGoogle">Continue with Google</span>
              </button>
            </p>
          </div>
          <div class="row mt-4">
            <div class="col">
              <p class="mb-3" *ngIf="loginProvider != 2">
                <a href="/signup" class="wp-primary">Don't have an account? <strong>Register Now!</strong></a>
              </p>
              <p class="mb-3" *ngIf="loginProvider == 2">
                <a href="/login" style="color: #4caf50">Use a different login method</a>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<app-footer></app-footer>